import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ILeftMenucopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ILeftMenucopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GetGuidanceDoc: any[];
  GetGuidanceDoc_dummy: any[];
  DownloadFile: any;
  DownloadFile_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  isComp63815Visible: "visible" | "hidden";
  isComp901672Visible: "visible" | "hidden";
  isComp725468Visible: "visible" | "hidden";
  isComp15857Visible: "visible" | "hidden";
  isComp101896Visible: "visible" | "hidden";
  isComp368105Visible: "visible" | "hidden";
  isComp340202Visible: "visible" | "hidden";
  isComp553154Visible: "visible" | "hidden";
  isComp815895Visible: "visible" | "hidden";
  isComp957276Visible: "visible" | "hidden";
  isComp210732Visible: "visible" | "hidden";
  isComp861165Visible: "visible" | "hidden";
  isComp556414Visible: "visible" | "hidden";
  isComp122268Visible: "visible" | "hidden";
  isCompleftmenucopy_63815AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_901672AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_725468AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_15857AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_101896AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_368105AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_340202AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_553154AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_815895AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_957276AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_210732AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_861165AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_556414AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_741736AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_122268AuthorizationVisible: "visible" | "hidden";
  isCompleftmenucopy_734963AuthorizationVisible: "visible" | "hidden";
}

export class LeftMenucopy_ScreenBase extends React.PureComponent<
  ILeftMenucopy_ScreenProps,
  any
> {
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 501123,
          PropertyName: "value",
          Value: "Menu",
          TagName: "lblTitle_value",
        },
        {
          Id: 188381,
          PropertyName: "value",
          Value: "Çıkış Yap",
          TagName: "lblLogout_value",
        },
        {
          Id: 444715,
          PropertyName: "value",
          Value: "Anasayfa",
          TagName: "Label8_value",
        },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Kullanıcı Bildirimi Oluştur",
          TagName: "Label11_value",
        },
        {
          Id: 335840,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label12_value",
        },
        {
          Id: 418566,
          PropertyName: "value",
          Value: "Anasayfa",
          TagName: "Label13_value",
        },
        {
          Id: 66896,
          PropertyName: "value",
          Value: "Koleksiyonlar",
          TagName: "Label14_value",
        },
        {
          Id: 882001,
          PropertyName: "value",
          Value: "Yan Doldurma",
          TagName: "Label16_value",
        },
        {
          Id: 795386,
          PropertyName: "value",
          Value: "Seri Sonu",
          TagName: "Label19_value",
        },
        {
          Id: 30709,
          PropertyName: "value",
          Value: "Hızlı Stok",
          TagName: "Label15_value",
        },
        {
          Id: 699736,
          PropertyName: "value",
          Value: "Raporlar",
          TagName: "Label21_value",
        },
        {
          Id: 565019,
          PropertyName: "value",
          Value: "Sepetim",
          TagName: "Label17_value",
        },
        {
          Id: 445619,
          PropertyName: "value",
          Value: "Favori Desenlerim",
          TagName: "Label22_value",
        },
        {
          Id: 791310,
          PropertyName: "value",
          Value: "Bildirimlerim",
          TagName: "Label20_value",
        },
        {
          Id: 513569,
          PropertyName: "value",
          Value: "Sosyal Medya",
          TagName: "Label18_value",
        },
        {
          Id: 499300,
          PropertyName: "value",
          Value: "Profilim",
          TagName: "Label23_value",
        },
        {
          Id: 736645,
          PropertyName: "value",
          Value: "Bilgi Dokümanı",
          TagName: "Label24_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 501123,
          PropertyName: "value",
          Value: "Menu",
          TagName: "lblTitle_value",
        },
        {
          Id: 444715,
          PropertyName: "value",
          Value: "Homepage",
          TagName: "Label8_value",
        },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Create User Notification",
          TagName: "Label11_value",
        },
        {
          Id: 335840,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label12_value",
        },
        {
          Id: 418566,
          PropertyName: "value",
          Value: "Homepage",
          TagName: "Label13_value",
        },
        {
          Id: 66896,
          PropertyName: "value",
          Value: "Collections",
          TagName: "Label14_value",
        },
        {
          Id: 882001,
          PropertyName: "value",
          Value: " Side Filling",
          TagName: "Label16_value",
        },
        {
          Id: 795386,
          PropertyName: "value",
          Value: "End of Series",
          TagName: "Label19_value",
        },
        {
          Id: 30709,
          PropertyName: "value",
          Value: "Quick Stock",
          TagName: "Label15_value",
        },
        {
          Id: 699736,
          PropertyName: "value",
          Value: "Reports",
          TagName: "Label21_value",
        },
        {
          Id: 565019,
          PropertyName: "value",
          Value: "My Basket",
          TagName: "Label17_value",
        },
        {
          Id: 445619,
          PropertyName: "value",
          Value: "Favorite Patterns",
          TagName: "Label22_value",
        },
        {
          Id: 791310,
          PropertyName: "value",
          Value: "Bildirimlerim",
          TagName: "Label20_value",
        },
        {
          Id: 513569,
          PropertyName: "value",
          Value: "Social Media",
          TagName: "Label18_value",
        },
        {
          Id: 499300,
          PropertyName: "value",
          Value: "Profile",
          TagName: "Label23_value",
        },
        {
          Id: 736645,
          PropertyName: "value",
          Value: "Information Document",
          TagName: "Label24_value",
        },
      ],
    },
    {
      Id: "e6911b3e-3ca5-4076-a2ef-c4d9b64afb0a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 501123, PropertyName: "value", Value: "Menu" },
        { Id: 444715, PropertyName: "value", Value: "Anasayfa" },
        {
          Id: 509283,
          PropertyName: "value",
          Value: "Kullanıcı Bildirimi Oluştur",
        },
        { Id: 335840, PropertyName: "value", Value: "Raporlar" },
        { Id: 418566, PropertyName: "value", Value: "Anasayfa" },
        { Id: 66896, PropertyName: "value", Value: "Koleksiyonlar" },
        { Id: 882001, PropertyName: "value", Value: "Yan Doldurma" },
        { Id: 795386, PropertyName: "value", Value: "Seri Sonu" },
        { Id: 30709, PropertyName: "value", Value: "Hızlı Stok" },
        { Id: 699736, PropertyName: "value", Value: "Raporlar" },
        { Id: 565019, PropertyName: "value", Value: "Sepetim" },
        { Id: 445619, PropertyName: "value", Value: "Favori Desenlerim" },
        { Id: 791310, PropertyName: "value", Value: "Bildirimlerim" },
        { Id: 513569, PropertyName: "value", Value: "Sosyal Medya" },
        { Id: 499300, PropertyName: "value", Value: "Profilim" },
        { Id: 446147, PropertyName: "value", Value: "Çeviri/Translate" },
        { Id: 736645, PropertyName: "value", Value: "Bilgi Dokümanı" },
        { Id: 188381, PropertyName: "value", Value: "Çıkış Yap" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      NAVIGATE: "",
      GetGuidanceDoc: [],
      DownloadFile: "",
      Logout: false,
      goToSignInActivity: "",
      isComp63815Visible: "hidden",
      isComp901672Visible: "hidden",
      isComp725468Visible: "hidden",
      isComp15857Visible: "hidden",
      isComp101896Visible: "hidden",
      isComp368105Visible: "hidden",
      isComp340202Visible: "hidden",
      isComp553154Visible: "hidden",
      isComp815895Visible: "hidden",
      isComp957276Visible: "hidden",
      isComp210732Visible: "hidden",
      isComp861165Visible: "hidden",
      isComp556414Visible: "hidden",
      isComp122268Visible: "hidden",
      isCompleftmenucopy_63815AuthorizationVisible: "visible",
      isCompleftmenucopy_901672AuthorizationVisible: "visible",
      isCompleftmenucopy_725468AuthorizationVisible: "visible",
      isCompleftmenucopy_15857AuthorizationVisible: "visible",
      isCompleftmenucopy_101896AuthorizationVisible: "visible",
      isCompleftmenucopy_368105AuthorizationVisible: "visible",
      isCompleftmenucopy_340202AuthorizationVisible: "visible",
      isCompleftmenucopy_553154AuthorizationVisible: "visible",
      isCompleftmenucopy_815895AuthorizationVisible: "visible",
      isCompleftmenucopy_957276AuthorizationVisible: "visible",
      isCompleftmenucopy_210732AuthorizationVisible: "visible",
      isCompleftmenucopy_861165AuthorizationVisible: "visible",
      isCompleftmenucopy_556414AuthorizationVisible: "visible",
      isCompleftmenucopy_741736AuthorizationVisible: "visible",
      isCompleftmenucopy_122268AuthorizationVisible: "visible",
      isCompleftmenucopy_734963AuthorizationVisible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("leftmenucopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.LeftMenucopyPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_63815AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_901672AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_725468AuthorizationVisible",
      [
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_15857AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_101896AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_368105AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_340202AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_553154AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_815895AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_957276AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_210732AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_861165AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_556414AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "B2BCustomer",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_741736AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_122268AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompleftmenucopy_734963AuthorizationVisible",
      [
        "fcf2aa80-320a-e0a6-9e78-02d60a07cc52",
        "605fa807-9b13-e323-c2b5-2198b67672c4",
        "b0582dca-d15e-93c3-7cb1-20c8fd8b886a",
        "af27e181-8ee4-f93d-64a9-9e2b5e056d6c",
        "B2BCustomer",
        "B2BAdmin",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight("leftmenucopy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer", "B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("leftmenucopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.LeftMenucopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  LeftMenucopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.isComp63815Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp901672Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp725468Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BAdmin"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp15857Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp101896Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp368105Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp340202Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp553154Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp815895Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp957276Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp210732Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp861165Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp556414Visible =
      ReactSystemFunctions.contains(
        ReactSystemFunctions.getMyRoleNames(),
        "B2BCustomer"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  LeftMenucopyComponent_620279_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_63815_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "HomePageAdmin",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_901672_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "AdminNotifManagement",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_725468_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "ReportsFirstPage",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_15857_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "HomePageCustomer",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_101896_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "ProductListCollectionWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_368105_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "ProductListCollectionSelectedWebScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_340202_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "EndOfProductCollectionWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_553154_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "HizliStokWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_815895_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "ReportsCustomer",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_957276_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "ProductBasketWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_210732_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "FavoritesListDesignWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_861165_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "CustomerNotifcationList",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_556414_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "SocialMedia",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_741736_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "Profile",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_958804_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "LeftMenucopy",
      "Translate",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "452818",
      null,
      "bottom",
      "true",
      "100%",
      "15%",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_734963_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "LeftMenucopy/LeftMenucopyComponent_734963_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetGuidanceDoc = result?.data.getGuidanceDoc;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.LeftMenucopyComponent_734963_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  LeftMenucopyComponent_734963_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetGuidanceDoc !== undefined
          ? stateVars.GetGuidanceDoc?.length > 0
            ? stateVars.GetGuidanceDoc[0].doc
            : null
          : this.state.GetGuidanceDoc?.length > 0
          ? this.state.GetGuidanceDoc[0].doc
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetGuidanceDoc !== undefined
          ? stateVars.GetGuidanceDoc?.length > 0
            ? stateVars.GetGuidanceDoc[0].docName
            : null
          : this.state.GetGuidanceDoc?.length > 0
          ? this.state.GetGuidanceDoc[0].docName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  LeftMenucopyComponent_20424_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      ,
      452818,
    ] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.LeftMenucopyPageInit();
    }
  }
}
